const ITEMS = [
  "Ascolto imparziale",
  "Tutela dei minori",
  "Riservatezza assoluta",
  "Accordi condivisi",
  "Legge 54/2006",
  "Riforma Cartabia",
  "Crotone e provincia",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="bg-night py-5 overflow-hidden border-y border-gold/20">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif italic text-lg sm:text-xl text-paper/90 px-6 whitespace-nowrap">{item}</span>
                <span className="text-gold text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
